<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <!-- <div class="personal-details">
          <h4 class="personal-details-title">Product Display Zone List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Zone Name</th>
                <th scope="col">No. of Products</th>
                <th scope="col">No. of products per-line</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of productDisplayZoneList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{product.zoneName}}</th>
                <th scope="col">{{product.productInfoObjList.length}}</th>
                <th scope="col">{{product.noOfProductsPerLine}}</th>
                <th>
                  <i class="bi bi-eye-fill" (click)="getProductDisplayZoneById(product.displayZoneId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="productDisplayZoneList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div> -->

        <div class="personal-details">
          
          <div class="header-block">
              <div class="header-title">
                  <p>Product Display Zone List</p>
              </div>
              <div class="add-block">
                  <div class="search">
                      <form autocomplete="off" >
                          <input type="text" placeholder="search">
                      </form>
                      <i class="bi bi-search" ></i>
                  </div>

              </div>
          </div>

          <table class="table table-striped">
              <thead>
                  <tr>
                    <th style="width: 50%">Zone Name</th>
                    <th style="width: 20%">No. of Products</th>
                    <th style="width: 20%">No. of products per-line</th>
                    <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                  </tr>
              </thead>
          </table>
          <div *ngIf="!isLoading">
              <div class="data-view" *ngFor="let product of productDisplayZoneList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <p style="width: 50%">{{product.zoneName}}</p>
                <p style="width: 20%">{{product.productInfoObjList.length}}</p>
                <p style="width: 20%">{{product.noOfProductsPerLine}}</p>
               
                <p style="width: 10%;text-align: center;padding: 0;">
                  <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getProductDisplayZoneById(product.displayZoneId)" data-toggle="modal" data-target="#exampleModalView"></i>
                  <i class="bi bi-trash3" (click)="selectProductDisplayZone(product.id)" data-toggle="modal" data-target="#deleteModal"></i>

                </p>
              </div>
          </div>


          <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
          </div>

          <div class="loader"  *ngIf="!isLoading && productDisplayZoneList.length == 0">
              <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
              </div>
              
          </div>

          <div class="paginator">
              <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
              </p-paginator>
          </div>


      </div>
      </div>
    </div>
</div>


<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Product Display Zone Data
          <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let product of singleProductDisplayZoneData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Name</label>
                <input type="text" readonly value="{{product.zoneName}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Price</label>
                <input type="text" readonly value="{{product.noOfProductsPerLine}}" class="form-control">
              </div>
            </div>
          </div>
          <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 10%;">ProductId</th>
                <th style="width: 30%;text-align: center;">Name</th>
                <th style="width: 30%;text-align: center;">Group</th>
                <th style="width: 30%;text-align: center;">Code</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let productInfoObjList of product.productInfoObjList;let i = index">
                <th>{{productInfoObjList.productId}}</th>
                <th style="text-align: center;">{{productInfoObjList.name}}</th>
                <th style="text-align: center;">{{productInfoObjList.group}}</th>
                <th style="text-align: center;">{{productInfoObjList.code}}</th>
              </tr>    
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>
      <div class="modal-footer">
        <button type="button" id="closeModalButton3"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="deleteProductDisplayZoneById()" class="btn btn-primary">Delete</button>
      </div>
    </div>
  </div>
</div>
</div>